export default {
  name: "ToolTip",
  props: {
    tip: String,
    translate: {
      type: [Number, String, Boolean],
      default: 0
    }
  }
};